import 'babel-polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import moment from "moment"
import eventBus from './event-bus';
import api from "./api"
import helpers from "./helpers"
import VueClipboard from 'vue-clipboard2'
import GoogleAuth from 'vue-google-oauth'
import Vue2Editor from "vue2-editor";
import VueMeta from 'vue-meta'

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.component('vue-phone-number-input', VuePhoneNumberInput);



Vue.filter('capitalizeFirstLetter', function (value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
})

Vue.filter('fromNow', function (value) {
  if (!value) return 'Never'
  return moment(value).fromNow()
})

Vue.filter('dateFormat', function (value) {
  if (!value) return 'Never'
  return moment(value).format('MMMM Do YYYY')
})

Vue.filter('decimal', function (v) {
  if (!v) {
    return '0.00'
  }
  return (v / 100).toFixed(2)
})

Vue.filter('limit_30', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 30) + (value.length > 30 ? "..." : "")
})
Vue.filter('limit_35', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 35) + (value.length > 35 ? "..." : "")
})
Vue.filter('limit_50', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 50) + (value.length > 50 ? "..." : "")
})

Vue.filter('limit_40', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 40) + (value.length > 40 ? "..." : "")
})

Vue.filter('limit_20', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 20) + (value.length > 20 ? "..." : "")
})

Vue.filter('limit_15', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 15) + (value.length > 15 ? "..." : "")
})

Vue.filter('limit_100', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 100) + (value.length > 100 ? "..." : "")
})

Vue.filter('limit_200', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 200) + (value.length > 200 ? "..." : "")
})

Vue.filter('limit_150', function (value) {
  if (!value) {
    return ''
  }
  return value.slice(0, 150) + (value.length > 150 ? "..." : "")
})

Vue.use(GoogleAuth, {
  client_id: '864599492835-ht5olo6v3om8i2oo6a4nnru69qtoglak.apps.googleusercontent.com'
})
Vue.googleAuth().load()
Vue.googleAuth().directAccess()

Vue.use(Vue2Editor);
Vue.use(VueClipboard)

Vue.config.productionTip = false
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$helpers = helpers;
Vue.prototype.$api = api;
Vue.prototype.$google = Vue.googleAuth()

function check_notifications() {
  if (store.getters['account/isLoggedIn']) {
    store.dispatch('notifications/load')
  }
  setTimeout(check_notifications, 20000)
}
setTimeout(check_notifications, 5000)

async function startup() {
  console.time("loadStore")
  console.time("loadApp")
  await store.dispatch('load')
  console.timeEnd("loadStore")
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
  console.timeEnd("loadApp")
}
startup()